import { FC, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Row, Col, message } from "antd";
import { Controller } from "react-hook-form";
import * as M from "moment";
import { useHandleForm } from "../../../../hooks/useHandleForm";
import ReportForm from "./ReportForm";
import {
  ExpandedTable,
  IButton,
  IDateTimePicker,
  StoredPagination,
  ITooltip,
} from "../../../../ui-kit";
import sitPanelReports from "../../../../store/sitPanelReportsStore";
import sitPanelAnalyticalReports from "../../../../store/sitPanelAnalyticalReportsStore";
import moment from "moment";
import Constants from "../../../../constants/Common";

import { TrashIco } from "../../../../assets/customIcons";
import styles from "./SitPanelReports.module.scss";

const AnalyticalReport: FC = observer(() => {
  const {
    titleIcons: { trash },
  } = Constants;
  const initialFocus = {};
  const { handleSubmit, control } = useHandleForm(null, null, initialFocus);

  const columns = [
    {
      title: "Дата и время формирования",
      dataIndex: "created",
      key: "created",
      sortable: true,
      render: (date: Date) =>
        date ? M(date).format(Constants.dateTimeFormat) : "",
    },
    {
      title: "Срок отчёта",
      key: "period",
      render: (record) => {
        if (record.dateTo) {
          return M(record.dateTo).format(Constants.dateTimeFormat);
        }
        return "";
      },
    },
    {
      title: "Исходный отчёт",
      dataIndex: "fileId",
      key: "fileId",
      render: (fileId) => {
        return fileId ? (
          <a
            onClick={(e) => {
              e.stopPropagation();
              sitPanelReports.downloadDoneReport(fileId);
            }}
          >
            Скачать
          </a>
        ) : null;
      },
    },
    {
      title: "Актуализированный отчёт",
      dataIndex: "newFileId",
      key: "newFileId",
      render: (newFileId) => {
        return newFileId ? (
          <a
            onClick={(e) => {
              e.stopPropagation();
              sitPanelReports.downloadDoneReport(
                newFileId,
                "Актуализированный отчёт",
              );
            }}
          >
            Скачать
          </a>
        ) : null;
      },
    },
    {
      title: "",
      key: "action",
      render: (text, record, index) => (
        <ITooltip title={trash} placement="right">
          <TrashIco onClick={() => onDeleteReport(record.id)} />
        </ITooltip>
      ),
      className: "delete-cell",
    },
  ];

  useEffect(() => {
    if (sitPanelReports.reportStatus) {
      message.info(sitPanelReports.reportStatus);
    }
    sitPanelReports.setActionResult(null);
  }, [sitPanelReports.reportStatus]);

  useEffect(() => {
    sitPanelAnalyticalReports.getReports();
  }, [
    sitPanelAnalyticalReports.sorter.changingKey,
    sitPanelAnalyticalReports.paginator.page,
    sitPanelAnalyticalReports.paginator.perPage,
  ]);

  const onSubmit = async (values) => {
    await sitPanelReports.downloadAnalyticalReport({
      dateTo: values.dateTo,
    });
    await sitPanelAnalyticalReports.getReports();
  };

  const onDeleteReport = async (id) => {
    await sitPanelReports.deleteReport(id);
    await sitPanelAnalyticalReports.getReports();
  };

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={styles.SitPanelReportsDateRange}
      >
        <Row gutter={[20]}>
          <Col>
            <Controller
              control={control}
              defaultValue={moment().format("YYYY-MM-DD[T]HH:mm")}
              name="dateTo"
              render={({ field }) => {
                return (
                  <IDateTimePicker
                    field={field}
                    placeholder="На дату"
                    dateInputReadOnly={false}
                  />
                );
              }}
            />
          </Col>
          <Col>
            <IButton>Сформировать</IButton>
          </Col>
        </Row>
      </form>
      <ExpandedTable
        columns={columns}
        sort={sitPanelAnalyticalReports.sorter}
        data={sitPanelAnalyticalReports.reports}
        rowKey={(record) => record.id}
        rowKeys={sitPanelAnalyticalReports.reportParamsRowKeys.keys}
        setRowKeys={sitPanelAnalyticalReports.reportParamsRowKeys.setKeys}
        rowsLength={sitPanelAnalyticalReports.paginator.perPage}
        loading={sitPanelAnalyticalReports.isLoading.value}
      >
        <ReportForm context={sitPanelAnalyticalReports} />
      </ExpandedTable>
      <StoredPagination {...sitPanelAnalyticalReports.paginator} />
    </>
  );
});

export default AnalyticalReport;
